import React from "react";
import "../../../App.css";
import "./BecomeAgent.css";
import podium from "../../Assets/podium 1.svg";
import suprise from "../../Assets/surprise 1.svg";
import people from "../../Assets/people.svg";
import dollar from "../../Assets/dollar 1.svg";

const BenefitOfAgent = () => {
  return (
    <div className="benefit-of-agent-container">
      <div className="benefit-of-agent-main">
        <div className="benefit-of-agent-header">
          <h5 className="benefit-title">BENEFITS</h5>
          <h5 className="driven-by-values">We’re Driven by our Values</h5>
          <p className="benefit-note">
          Get high returns as compared to bank saving account. Enjoy amazing OVEST features with  referral 
          bonus on every investor you refer. This return on your investment can be used toward major financial goals.
          </p>
        </div>
        <div className="salary-and-bonus-container">
          <div className="the-attractive-salary">
            <div>
              <img src={dollar} alt="" className="image-wrapper-salary" />
            </div>
            <h5 className="bonus-title">Attractive Salary</h5>
            <p className="bonus-details">
              As an iRepOVestpartner you are entitled to a monthly salary on
              reaching goals
            </p>
          </div>
          <div className="the-bonus-community ">
            <div>
              <img src={suprise} alt="" className="image-wrapper-bonus" />
            </div>
            <h5 className="bonus-title">Bonus</h5>
            <p className="bonus-details">
              An active and driven community to help empwer, support and
              inforrm.
            </p>
          </div>
        </div>
        <div className="driven-community-main">
          <div className="the-attractive-salary">
            <div>
              <img src={people} alt="" className="image-wrapper-community" />
            </div>
            <h5 className="bonus-title">Driven Community</h5>
            <p className="bonus-details">
              The first partner to reach the super goal is entitled to a 7day
              trip to Dubai
            </p>
          </div>
          <div className="the-leader-board">
            <div>
              <img src={podium} alt="" className="image-wrapper-podium" />
            </div>
            <h5 className="bonus-title">Leader-board</h5>
            <p className="bonus-details">
              Partners can view their progress globally.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BenefitOfAgent;
